import Axios from 'axios';
import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import { VueEditor, Quill } from "vue2-editor";

export default Vue.extend({
    components: {
        Confirm,
         VueEditor
    },

    data: () => ({
        customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block", "video", "link"]
      ],
        e6: 1,
        tab: 0,
        dialog: false,
        valid: true,
        snackbar: false,
        jobName: '',
        jobDescription: '',
        websiteLink : '',
        cName:'',
        qualificationId : '',
        proficiency: '',
        experienceId:'',
        selectCheck : [],    
        showMessage : '',
        ctcValue : '',
        filteredQualification:[],
        filteredProficiency:[],
        filteredSubject : [],
        allExperience : [],
        alljobLocation : [],
        filteredField : [],
        jobLocation : '',
        potentialForassignments : '',
        jobFunction:'',
        fullTimeIntern : '',
        job_id : 0,
        streamField : false,
        descriptclass : false,
        formatDate : '',
        CtcType : [{id:0,type:'INR'},{id:1, type:'USD'}],
        internType : false,
        filteredStream : [],
        streamId : [],
        dateTime : [],
        dateModify : false,
        frmattableRow : [],
        tableRow : [
            {
                proficiency : '',
                cyear : ''
            }
        ], 
        subjectAdd : [{
            subject : '',
            grade : 0,
            exam_number : 0
        }],
        timeArray : ['per year', 'per month', 'per hour'],
        addplus : false,    
        addSubjectplus:false,
        allcity : [],
        city : '',
        menu : false,
        dates:[],
        jobsavedates :[],
        area : '',
        myDate : '',
        ctcType : '',        
        emplymentType: [{ id: 1, empType: 'Full Time' },
        {
            id: 2,
            empType: 'Part Time'
        },
        {
            id: 3,
            empType: 'Intern'
        },
        {
            id: 4,
            empType: 'Intern to Hire'
        },


        ],
        offshoreType: [{ offType: 'Yes' },
        { offType: 'No' }],
        ctcTime: '',
        filteredGrade : [{data:'Grade A(71-100)',value : 1},
            {data : 'Grade B(51-70)',value : 2},
            {data : 'Grade C(31-50)',value : 3},
            {data : 'Grade D(<=30)',value : 4}
        ],
        paidType : ['Paid', 'Unpaid'],
        ctcShw : true,
        cmpan_value : '',
        candidatenumbers : 0,
        frmatselectCheck : [],
        frmatscore : [],
        frmatqualificationId : '',
        frmatstream : '',
        modal1 : false,
        time:null,
        userId : '',
        statename : '',
        cityName : '',
        imageUrl : '',
        fieldId : [],
        comapany_description : '',
        updateid : 0,
        specific_subject_marks : 0,
        category : '',
        dataLoading : false,
        streamName : '',
        semfeild_name :[],
        eduarr : [],
        showDialog : false,
        marks_10th :0,
        markstype :['Percent', 'CGPA', 'Point'],
        marks_unit :'',
        tenyear:'',
        allowedDates : ["2021-07-10", "2021-07-11"],
        science_marks : 0,
        science_marks_unit : '',
        marks_12th: 0,
        marks_12th_unit:'',
        pcm_marks : 0,
        pcm_marks_unit : '',
        year_12_modal : '',
        tYears :[],

        jobNameRequired: [
            (v: boolean) => !!v || "Title is required",
            //@ts-ignore
           // (v: boolean) => /^[a-zA-Z][\sa-zA-Z]+[0-9]*$/.test(v) || 'First character must be a letter and special character and number not to be allowed.',
            //@ts-ignore
            //(v: boolean) => /^[a-zA-Z0-9 ]+(([\'\,\&\- ][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/.test(v) || "Only alphabets ',' and '&' are allowed in job name",
            // (v: boolean) => /^[a-zA-Z0-9,.&']*$/.test(v) || "Only alphabets, numbers ',' , '.', and '&' are allowed in job title",
            //@ts-ignore
            (v: boolean) => /^\S/.test(v) || 'Blank space is not allowed at first character',
           //@ts-ignore
            (v: boolean) => v.length <= 100 || 'Title must be less than 100 characters',
        ],

        vaccancyNumberrequired :[
            v => (v && v>0) || 'Please choose number of vaccancy',
            //@ts-ignore
            (v: boolean) => /^[0-9]+$/.test(v) || 'Vacancies only accept number'
        ],
       
        jobDescriptionRequired:[
            (v: boolean) => !!v || "Description is required",
            //@ts-ignore
            // (v: boolean) => v.length <= 1000 || 'Job description must be less than 1000 characters',
        ],
        websitelinlRequired : [
            (v: boolean) => !!v || "Please enter a website link",
            //@ts-ignore
           // (v: boolean) => /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/.test (v) || 'Please enter proper website link'
            (v: boolean) => /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test (v) || 'Please enter proper website link'
        ],
        cNameRequired:[
            (v: boolean) => !!v || "Company Name is required",
        ],
        qualificationRequired: [
            v => (v && v.length>0) || 'Please choose qualification.'
        ],
        proficiencyRequired : [
            (v: boolean) => !!v || 'Please choose tools/languages'
        ],
        dateRequired : [
            v => (v && v.length>0) || "Select any date"
        ],
        subjectRequired : [
            (v: boolean) => !!v || 'Please choose crackingIT subject'
        ],
        cdingExperienceRequired : [
            (v: boolean) => !!v || 'Please enter years',
             //@ts-ignore
            (v: boolean) => /^[0-9 \-]+$/.test (v) || 'Only Numbers and hyphen are allowed in ',
        ],

        experienceRequired : [
            (v: boolean) => !!v || 'Please choose experience'
        ],
        jobLocationRequired :[(v: boolean) => !!v || 'Please choose state'],
        scoreRequired:[
            (v: boolean) => !!v || "CrackingIt Score is required",
            v => ( v && v >= 0 ) || "Score should be above 0",
            v => ( v && v <= 100 ) || "Score should not be above 100",
        ],
        exam_number_Required : [
            (v: boolean) => !!v || "Number of exam is required",
            v => ( v && v > 0 ) || "Number of exam should be above 0 ",
            v => ( v && v <= 3 ) || "Number of exam should not be above 3",
        ],
        ctcValueRequired : [
            (v: boolean) => !!v || "Compensation is required",
            //@ts-ignore
            // (v: boolean) => /^[0-9]\d{3}+[LK]\d{1}$/.test(v) || 'First character must be a letter',
            
        ],
        jobFunctionRequired:[
            (v: boolean) => !!v || " Job function is required ",
        ],
        fullTimeRequired:[
            (v: boolean) => !!v || "Field is required ",
        ],
        cityRequired : [
            (v: boolean) => !!v || 'Select a city'
        ],
        areaRequired : [
            (v: boolean) => !!v || "Address is required ",
        ],
        ctcTypeRequired : [
            (v: boolean) => !!v || "Please choose compensation type ",
        ],
        ctctimeRequired : [
            (v: boolean) => !!v || "Please choose compensation in year, month or hour",
        ],
        potentialRequired : [(v: boolean) => !!v || "Offshore Assignments is required"],
        streamRequired : [
            v => (v && v.length>0) || "Please select semester"
        ], 
        timeRequired : [
            (v: boolean) => !!v || "Please select time"
        ],
        streamFieldRequired : [
            v => (v && v.length>0) || "Stream Name is required ",
        ],
        fieldNameRequired: [
            v => (v && v.length>0 ) || "Please select a Stream."
        ],
        // marks10thRequired : [
        //     v => ( v && v > 0 ) || "Marks should be above 0",
        //     v => ( v && v <= 1000 ) || "Marks should not be above 1000",
        // ],
        // marks12thRequired : [
        //     v => ( v && v > 0 ) || "Marks should be above 0",
        //     v => ( v && v <= 600 ) || "Marks should not be above 600",
        // ],
        // marksUnit : [
        //     (v: boolean) => !!v || "Select any unit"
        // ],
        // passYear:[
        //     (v: boolean) => !!v || "Select your passout year"
        // ]

      
    }),

    async created() {
        this.updateid = this.$route.params.id
        this.job_details();
        await this.initialize();
        
        
        let d = new Date(); d.setDate(d.getDate() + 7);
        let mm = ((d.getMonth() + 1) < 10 ? '0' : '') + (d.getMonth() + 1);
        let dd = (d.getDate() < 10 ? '0' : '') + d.getDate(); 
        let yy = d.getFullYear();
        this.myDate= yy + '-' + mm + '-' + dd;
        localStorage.removeItem("JobId");
    },

    computed : {
        years () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1970}, (value, index) => year - index)
        },
        rules(){
            return [
                this.selectCheck.length >0 || "At least one working mode should be selected"
            ]
        },
    },

    beforeRouteLeave(to, from, next) {
        if (this.jobName == '' && this.jobDescription == '' && this.fieldId.length == 0 && this.qualificationId.length == 0 && this.streamId.length==0 && this.tableRow[0].proficiency == '' && this.tableRow[0].cyear=='' && 
            this.subjectAdd[0].subject=='' && this.subjectAdd[0].grade==0  && this.subjectAdd[0].exam_number ==0 && this.candidatenumbers ==0 
            && this.fullTimeIntern =='' && this.cmpan_value =='' && this.ctcType ==''&& this.ctcValue ==''&& this.ctcTime =='' && this.potentialForassignments =='' && this.jobFunction =='' 
            && this.dates.length ==0 && this.selectCheck.length ==0 && this.jobLocation =='' && this.city ==''&& this.area =='') {
                next();
        } else {
            this.leave();
            // this.showDialog = true;
            this.to = to.name
            console.log("else",to.name);
        }
    },


    methods:{
        getAllowedDates (val) {
            if (this.allowedDates.indexOf(val) !== -1) {
              return true
            } else {
              return false
            }
          },
        async job_details(){
            this.tableRow =[]; this.qualificationId = [];
            this.subjectAdd =[];
            this.dataLoading = true;
            let token =  localStorage.getItem("jwt");
            if (token) {
                const auth = {
                    headers: {authorization: token} 
                }   
                let response = await this.$http.get('/job/fetchParticularJob/'+this.updateid,auth)
                if (response.status === 200 && response.data.message === "Jobs found"){
                    this.jobName = response.data.jobs.job_title=='N/A'?'':response.data.jobs.job_title;
                    this.jobDescription = response.data.jobs.job_description=='N/A'?'':response.data.jobs.job_description ;
                    this.websiteLink = response.data.jobs.company_website =='N/A'?'':response.data.jobs.company_website;
                    this.cName = response.data.jobs.company_name;
                    this.candidatenumbers = response.data.jobs.open_positions;
                    this.fullTimeIntern = response.data.jobs.employment_type;
                    this.cmpan_value = response.data.jobs.internship_type;
                    this.unpaid(this.cmpan_value);
                    this.selectCheck = response.data.jobs.work_type;
                    this.area = response.data.jobs.area;
                    this.jobLocation = response.data.jobs.state.length>0?response.data.jobs.state[0].state_id:'';
                    this.statename = response.data.jobs.state.length>0?response.data.jobs.state[0].state_name:'';
                    console.log("*** this.statename **",this.statename )
                    this.stateChange(this.jobLocation);
                    this.city = response.data.jobs.city.length>0?response.data.jobs.city[0].city_id:''; 
                    this.cityName = response.data.jobs.city.length>0?response.data.jobs.city[0].city_name:''; 
                    console.log("*** this.cityName **",this.cityName )
                    if (this.fullTimeIntern == "Internship" || this.fullTimeIntern == "Summer Internship" || this.fullTimeIntern == "Internship to job" || this.fullTimeIntern == "Winter Internship") {
                        this.internType = true; 
                    }
                    this.imageUrl = response.data.jobs.company_profile_image;
                    this.category = response.data.jobs.company_category;
                    this.comapany_description = response.data.jobs.comapany_description;
                    this.ctcType = response.data.jobs.compensation_type;
                    this.ctcValue = response.data.jobs.expected_conpensation=='N/A'?'':response.data.jobs.expected_conpensation;
                    this.ctcTime = response.data.jobs.compensation_unit;
                    this.potentialForassignments = response.data.jobs.offshore_assignment;
                    this.jobFunction = response.data.jobs.job_function;
                    if (response.data.jobs.academic.length>0) {
                        this.marks_10th = response.data.jobs.academic[0].academic_marks;
                        this.marks_unit = response.data.jobs.academic[0].academic_marks_unit;
                        this.tenyear = response.data.jobs.academic[0].passout_year;
                        this.science_marks = response.data.jobs.academic[0].special_academic_marks;
                        this.science_marks_unit = response.data.jobs.academic[0].special_academic_marks_unit;
                        this.marks_12th = response.data.jobs.academic[1].academic_marks;
                        this.marks_12th_unit = response.data.jobs.academic[1].academic_marks_unit;
                        if (this.tenyear!='') {
                            this.getPassYear()
                        }
                        this.year_12_modal = response.data.jobs.academic[1].passout_year;
                        this.pcm_marks = response.data.jobs.academic[1].special_academic_marks;
                        this.pcm_marks_unit = response.data.jobs.academic[1].special_academic_marks_unit;
                    }

                    response.data.jobs.field.forEach(e4 => {
                        this.fieldId.push(e4.field_id);
                    });
                   
                    await this.getqualificatin();
                 

                    response.data.jobs.degree.forEach(element => {
                        this.qualificationId.push(element.degree_id);
                    });
                    
                    if (response.data.jobs.skills.length>0) {
                        response.data.jobs.skills.forEach(e2 => {
                            this.tableRow.push({
                                proficiency : e2.skills_id,
                                cyear :  e2.familiar_for_years
                            })
                        });
                    } else {
                        this.tableRow = [{
                            proficiency : '',
                            cyear :  ''
                        }]
                    }
                    this.addplus = true;
                    
                    response.data.jobs.semester.forEach(element => {
                        this.streamId.push(element.semester_id);
                    });

                    console.log('*** Subject***',response.data.jobs.subjects);
                    

                    if (response.data.jobs.subjects.length>0) {
                        response.data.jobs.subjects.forEach(e3 => {
                            this.subjectAdd.push({
                                subject : e3.subject_id,
                                grade :  e3.crackingit_grade,
                                exam_number : e3.number_of_exam_required
                            })
                        });
                    }else{
                        this.subjectAdd = [{
                            subject : '',
                            grade :  0,
                            exam_number : 0
                        }]
                    }
                    this.addSubjectplus = true;

                    response.data.jobs.exam_dates.forEach(el => {
                        let date = new Date(el * 1000);
                        console.log('**** date ***', date.getFullYear());
                        console.log('**** date ***', date.getDate());
                        let m = (date.getMonth()+1) > 9 ? (date.getMonth()+1) : '0'+(date.getMonth()+1);
                        console.log('**** M ***', m)
                        this.jobsavedates.push(date.getFullYear()+
                        "-"+m+"-"+date.getDate())
                    });

                    let updateTime = new Date(response.data.jobs.exam_dates[0] * 1000); 
                    this.time = response.data.jobs.exam_dates.length>0? updateTime.getHours()+":"+updateTime.getMinutes():null;
                    
                                
                }
                this.dataLoading = false;
            }
        },
        async initialize() {
            try {
               
                let token =  localStorage.getItem("jwt");
                this.userId= localStorage.getItem("userId");
                if (token && this.userId) {            
                    const auth = {
                        headers: {authorization: token} 
                    }           
                   
                    let fieldres = await this.$http.get('/job/fetchField', auth);
                    this.filteredField = fieldres.data.field;
                    // ****************** fetch degree ********************//
                    let resp = await this.$http.get('/job/fetchDegree/',auth)
                    this.filteredQualification = resp.data.degree;
                    
                    // ********** fetch stream ********************* //
                    let fetchresp = await this.$http.get('/job/fetchSemester',auth)
                    this.filteredStream = fetchresp.data.semester;

                    // ********** fetch skills ********************* //
                    let resultskill = await this.$http.get('/job/fetchSkills',auth)
                    this.filteredProficiency = resultskill.data.skills;

                    // ********** fetch subject ********************* //
                    let resultSubject = await this.$http.get('/job/fetchSubject',auth)
                    this.filteredSubject = resultSubject.data.subject;

                    // ********** fetch subject ********************* //
                    let resultState = await this.$http.get('/job/fetchState',auth)
                    console.log("res",resultState);
                    console.log("resp",resultState.data);
                    this.alljobLocation = resultState.data.state;
                }
            } catch (error) {
                console.log('Something went wrong, please try again later.');
            }
        },

        getPassYear(){
            const year = new Date().getFullYear()
            
            console.log('year',year);
            console.log('Year',this.tenyear);
            this.tYears = Array.from({length: year - this.tenyear}, (value, index) => year - index+1)
            console.log('value',this.tYears);
        },

        async getqualificatin(){
            if (this.fieldId.includes('60bb917117d7efec3a222cbc') || this.fieldId.includes('60bb917f17d7efec3a222cbd')) {
                this.streamField = true; 
            } else {
                this.streamField = false;
            }
        },

        async stateChange(event){
            let token =  localStorage.getItem("jwt");
            if (token) {
                const auth ={
                    headers: {authorization: token}
                };
                let resultcity = await this.$http.get('/job/fetchCity/'+event,auth)
                this.allcity = resultcity.data.city;
                this.alljobLocation.forEach((e1)=>{
                    if(e1._id === this.jobLocation){
                      this.statename = e1.state_name;
                    }
                });
            }
        },

        citySave(){
            this.allcity.forEach((e1)=>{
                if(e1._id === this.city){
                    this.cityName = e1.city_name;
                }
            });
        },    
    

        cancel() {
            this.backPage();
        },
        backPage() {
            window.history.back()
        },

        dateModifyClick(){
            this.dateModify = true;
        },
      
        addData(){
            console.log("length",this.tableRow.length);
            
            if(this.tableRow[this.tableRow.length-1].proficiency !=''){
                this.tableRow.push({
                    proficiency : this.proficiency,
                    cyear : this.cyear
                });
                if (this.tableRow.length>1) {
                    this.addplus = true;
                } else {
                    this.addplus = false;
                }
            }
            console.log("this.table", this.tableRow);
        },

        addsubject(){
            if(this.subjectAdd[this.subjectAdd.length-1].subject !='' && this.subjectAdd.length<5){
                this.subjectAdd.push({
                    subject : this.proficiency,
                    grade : this.grade,
                    exam_number : this.exam_number
                });
                if (this.subjectAdd.length>1) {
                    this.addSubjectplus = true;
                } else {
                    this.addSubjectplus = false;
                }
            }
            console.log("this.table", this.subjectAdd);
        },

        empType(event) {
            console.log("test")
            if (event == "Full Time" || event == "Part Time" || event == "Intern" || event == "Intern to Hire") {
                this.internType = true;
                this.ctcShw = false;
            } else {
                this.internType = false;
                this.ctcShw = true;
            }
        },

        unpaid(event) {
            if (event == 'Unpaid') {
                this.ctcShw = false; 
            } else {
                this.ctcShw = true; 
            }
        },

        delData(i){
            console.log("i value =", i);
            console.log("length", this.tableRow.length);
            if(this.tableRow.length>2){
                // this.addplus = false;
                //this.tableRow.pop();
                this.tableRow.splice(i,1);
               
                console.log("this.table", this.tableRow);
            }
            else  if(this.tableRow.length==2){
                this.tableRow.splice(i,1);
                this.addplus = false;
            }

        },

        delsubject(i){
            if (this.subjectAdd.length>2) {
                this.subjectAdd.splice(i,1);
            }
            else  if(this.subjectAdd.length==2){
                this.subjectAdd.splice(i,1);
                this.addSubjectplus = false;
            }
        },

        
    
        async saveRecruitData() {
            if (this.$refs.jobCreateForm.validate()) {
                this.dialog = true;

                if (this.dates.length>0) {
                    for(let i=0;i<this.dates.length;i++){
                        this.dateTime.push(this.dates[i]+'--'+this.time);
                    }
                } else {
                    for(let i=0;i<this.jobsavedates.length;i++){
                        this.dateTime.push(this.jobsavedates[i]+'--'+this.time);
                    }
                }
            
                this.filteredProficiency.forEach((e1)=>this.tableRow.forEach((e2)=> {
                    if(e1._id === e2.proficiency){
                        this.frmattableRow.push({
                            proficiency : e1.skill_name,
                            cyear : e2.cyear
                        });
                    }
                }));

                this.filteredField.forEach(element => this.fieldId.forEach((e2)=> {
                    if(element._id === e2){
                        if(e2 == '60bb917117d7efec3a222cbc' || e2 == '60bb917f17d7efec3a222cbd') {
                            let st = this.streamName.split(',')
                            for (let i = 0; i < st.length; i++) {
                                if (this.semfeild_name.includes(st[i]) === false) this.semfeild_name.push(st[i]); 
                            }                        
                        } else {
                            this.semfeild_name.push(element.field_name);
                        }
                    }
                }));
            
            
                this.formatDate = this.dateTime.join(", "); 
                this.frmatselectCheck = this.selectCheck.join(", "); 
                let sem = [];
                this.filteredQualification.forEach((e1)=>this.qualificationId.forEach((e2)=> {
                    if(e1._id === e2){
                        this.eduarr.push(e1.degree_name)
                    }
                }));
                this. frmatqualificationId = this.eduarr.join(", "); 

                this.filteredStream.forEach((e1)=>this.streamId.forEach((e2)=> {
                    if(e1._id === e2){
                        sem.push(e1.current_semester)
                    }
                }));
                this.frmatstream = sem.join(", ");            
                this.filteredSubject.forEach((e1)=>this.subjectAdd.forEach((e2)=> {
                    if(e1._id === e2.subject){
                        this.frmatscore.push({
                            'subject_id' : e1._id,
                            'subject_name' : e1.subject_name,
                            'crackingit_grade' : e2.grade,
                            'minimum_crackingit_percentile' : 0,
                            number_of_exam_required : e2.exam_number
                        });
                    }
                }));
            }
        },
        saveJob(){
            if (this.$refs.jobCreateForm.validate()) {
               this.applyJob(1);
            }
        },
        async applyJob(num){
            try {
                this.dataLoading = true;
                console.log ("subjectAdd",this.subjectAdd) 
                let qual = [];
                let field = [];
                let semester = [];
                let skill= [];
                let alldate = [];
                this.frmatscore = [];
                let user_id = localStorage.getItem("userId");
                let token =  localStorage.getItem("jwt");
                if (token) {  
                    const auth = {
                        headers: {authorization: token} 
                    }      
                    if (this.streamName != '' ) {
                        let st = this.streamName.split(',')
                        for (let i = 0; i < st.length; i++) {
                            let resp = await this.$http.post('/job/createField',{
                                field_name:  st[i],
                                user_id: user_id
                            },auth​​​​​​​​)
                            console.log ("resp",resp);
                            if (resp.status === 200) {
                                field.push({
                                    'field_id' : resp.data.field_stored._id,
                                    'field_name' : resp.data.field_stored.field_name
                                });
                            }
                        }
                    }

                    this.filteredField.forEach((el1) => this.fieldId.forEach((el2)=>{
                        if (el1._id == el2){
                            if (el2=='60bb917117d7efec3a222cbc' || el2 == '60bb917f17d7efec3a222cbd'){ 
                            }
                            else{
                                field.push({
                                    'field_id' :el2,
                                    'field_name' : el1.field_name
                                });
                            }
                        }
                    }))    
                    this.filteredQualification.forEach((e1)=>this.qualificationId.forEach((e2)=> {
                        if(e1._id === e2){
                            qual.push({
                                'degree_id' : e1._id,
                                'degree_name' : e1.degree_name
                            });
                        }
                    }));
                   

                    this.filteredStream.forEach((e1)=>this.streamId.forEach((e2)=> {
                        if(e1._id === e2){
                            semester.push({
                                'semester_id' : e1._id,
                                'semester_name' : e1.current_semester
                            });
                        }
                    }));


                    this.filteredProficiency.forEach((e1)=>this.tableRow.forEach((e2)=> {
                        if(e1._id === e2.proficiency){
                            skill.push({
                                'skills_id' : e1._id,
                                'skills_name' : e1.skill_name,
                                'familiar_for_years' : e2.cyear
                            });
                        }
                    }));

                    this.filteredSubject.forEach((e1)=>this.subjectAdd.forEach((e2)=> {
                        if(e1._id === e2.subject){
                            this.frmatscore.push({
                                'subject_id' : e1._id,
                                'subject_name' : e1.subject_name,
                                'crackingit_grade' : e2.grade,
                                'minimum_crackingit_percentile' : 0,
                                number_of_exam_required : e2.exam_number
                            });
                        }
                    }));

               
                if (this.dates.length==0) {
                    this.jobsavedates.forEach(element => {
                        let datetime = element+' '+this.time+':00'; console.log('unixtime:',datetime);
                        let unixtime = Date.parse(datetime)/1000;
                        console.log('unixtime:',unixtime);
                        alldate.push(unixtime);
                    });
                }
                else{
                    this.dates.forEach(element => {
                        let datetime = element+' '+this.time+':00'; console.log('unixtime:',datetime);
                        let unixtime = Date.parse(datetime)/1000;
                        console.log('unixtime:',unixtime);
                        alldate.push(unixtime);
                    });
                }
                
                let intern_value = this.cmpan_value != ''?this.cmpan_value:'N/A';
             
                console.log ("field",field) 
                console.log ("field_length",field.length) 
                let token2 =  localStorage.getItem("jwt");
              
                              
                    let getResult = await this.$http.post('/job/updateJob',{
                        'job_id' : this.updateid,
                        'job_title': this.jobName!=''?this.jobName:'N/A',
                        'job_description': this.jobDescription!=''?this.jobDescription:'N/A',
                        "company_profile_image": this.imageUrl,
                        "company_name": this.cName!=''?this.cName:'N/A',
                        "company_website": this.websiteLink!=''?this.websiteLink:'N/A',
                        "field": field.length>0?field:[],
                        "degree": qual.length>0?qual:[],
                        "semester": semester.length>0?semester:[],
                        'comapany_description' : this.comapany_description!=''?this.comapany_description:'N/A',
                        'open_positions': this.candidatenumbers,
                        'job_function': this.jobFunction!=''?this.jobFunction:'N/A',
                        'category' : this.category,
                        is_draft : num,
                        'employment_type': this.fullTimeIntern!=''?this.fullTimeIntern:'N/A',
                        'internship_type' : this.fullTimeIntern === 'Job' ? 'Paid' : intern_value,
                        'compensation_type': this.ctcType!='' ? this.ctcType : 'N/A',
                        "expected_conpensation": this.ctcValue!='' ? this.ctcValue : 'N/A',
                        "compensation_unit": this.ctcTime!=''?this.ctcTime : 'N/A',
                        "work_type": this.selectCheck.length>0?this.selectCheck:[],
                        "offshore_assignment": this.potentialForassignments != ''?this.potentialForassignments:'N/A',
                        "user_id": this.userId,
                        "subjects": this.frmatscore.length>0?this.frmatscore:[{'subject_id': '','subject_name' :'',
                        'minimum_crackingit_percentile' :0,number_of_exam_required :0}],
                        academic: [{
                            academic_name: '10th Standard',
                            passout_year:  this.tenyear,
                            academic_marks: this.marks_10th,
                            academic_marks_unit: this.marks_unit!=''?this.marks_unit:'N/A',
                            special_academic_name: 'Science',
                            special_academic_marks: this.science_marks,
                            special_academic_marks_unit: this.science_marks_unit!=''?this.science_marks_unit:'N/A'
                        },{
                            academic_name: '12th Standard',
                            passout_year:  this.year_12_modal,
                            academic_marks: this.marks_12th,
                            academic_marks_unit: this.marks_12th_unit!=''?this.marks_12th_unit:'N/A',
                            special_academic_name: 'PCM',
                            special_academic_marks: this.pcm_marks,
                            special_academic_marks_unit: this.pcm_marks_unit!=''?this.pcm_marks_unit:'N/A'
                        }],
                        "state": this.jobLocation!=''?[
                        {​​​​​​​​
                            "state_id": this.jobLocation,
                            "state_name": this.statename
                        }​​​​​​​​]:[],
                        "city": this.city!=''?[
                        {​​​​​​​​
                            "city_id": this.city,
                            "city_name": this.cityName
                        }​​​​​​​​]:[],
                        'area':this.area!=''?this.area:'N/A',
                        'skills': skill.length>0?skill:[],
                        'exam_dates': alldate.length>0?alldate:[],
                        'urls': this.websiteLink!=''?[{​​​​​​​​
                            'url_name': 'Company_link',
                            'url': this.websiteLink
                        }​​​​​​​​]:[]
                    },auth)​​​​​​​​
                    await this.showResult(getResult);
                }
            }
            catch(error){
                this.snackbar = true;
                this.showMessage = 'Not created!! Please try again.'
                this.dataLoading = false;
            }
        },

        async showResult(getResult){
            console.log("tfstyfasdf");
            if(getResult.status===200 && getResult.data.message === 'Job updated successfully' && getResult.data.is_draft === 1){
                this.routeResult(true,'Job saved successfully.',false,'my-jobs') 
                this.job_id = getResult.data.job;
                localStorage.setItem("JobId",this.job_id);        
            }
            else if(getResult.status===200 && getResult.data.message === 'Job updated successfully' && getResult.data.is_draft ===2){
                this.routeResult(true,'Job saved as draft.',false,'draft_job')            
            }
        },

        agree() {
            // this.showDialog = false;
            this.applyJob(2);
        },

        routeResult(f1,msg,f2,path){
            console.log("enter resukr");
            this.snackbar = f1;
            this.showMessage = msg,
            this.dataLoading = f2;
            console.log({ name: typeof this.to!='undefined' && this.to!=''?this.to:path});
            this.jobName=''; this.jobDescription=''; this.fieldId.length=0;this.qualificationId.length = 0;
            this.streamId.length = 0;  this.tableRow[0].proficiency = ''; this.tableRow[0].cyear='';this.subjectAdd[0].subject='';this.subjectAdd[0].grade=0; this.subjectAdd[0].exam_number =0; this.candidatenumbers =0 ;this.fullTimeIntern =''; this.cmpan_value ='';this.ctcType ='';this.ctcValue ='';
            this.ctcTime =''; this.potentialForassignments =''; this.jobFunction ='';this.dates.length =0;this.selectCheck.length=0; this.jobLocation =''; this.city =''; this.area='';
            
            this.$router.replace({ name: typeof this.to!='undefined' && this.to!=''?this.to:path})
        },
    
        close() {
            this.dialog = false;
            this.$router.push({ name: 'home' });
        },
        update() {
            this.dialog = false;
        },
        save_draft() {
            this.applyJob(2);
        },
        draft_job(){
            this.$router.replace({ name: 'draft_job'})
        },

        async leave(){
            
            this.$swal({
             title: 'Would you like to save this job as draft?',
             text: '',
             icon: 'info',
             showCancelButton: true,
             confirmButtonText: 'Save',
             cancelButtonText:'Cancel',
             customClass: 'swal-title-jobapplication'
         }).then((result) => {
           if (result.isConfirmed) {
             this.agree();
           }else{
               this.routeResult(false,'',false,'')
           }
          
          })
       },

    },
});
